import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { groupsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Switch from "components/Switch";
import * as groupsActions from "actions/groupsActions";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import { withTranslation } from "react-i18next";
import {
	applySupervisorPermissionChange,
	getSupervisorPermissionGroups,
	isPermissionDisabled,
	isPermissionEnabled,
	isSupervisorEmployeeMissing,
	normalizeSupervisorPermissions,
} from "./supervisorPermissions";

class GroupSupervisorEdit extends React.Component {
	employeeSelectFetchOptions = { enabled: true };

	constructor(props) {
		super(props);

		let group_supervisor = {
			employee_id: -1,
			read_only: false,
			second_level: false,
			edit_employees: false,
			edit_shifts: false,
			edit_staffing_levels: false,
			edit_groups: false,
			edit_documents: false,
			request_signaturit: false,
			view_time_registrations: true,
			manage_workflows: true,
		};

		let isEdit = false;

		if (props.group_supervisor) {
			group_supervisor = props.group_supervisor;
			group_supervisor.employee_id = group_supervisor.employee.id;
			group_supervisor.id = group_supervisor.id;
			group_supervisor.view_time_registrations =
				group_supervisor.view_time_registrations ?? true;
			group_supervisor.request_signaturit =
				group_supervisor.request_signaturit ?? false;
			group_supervisor.manage_workflows =
				group_supervisor.manage_workflows ?? true;
			isEdit = true;
		}

		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			group_supervisor,
			isEdit,
		};
	}

	handleSupervisorEmployeeChange = (idOrNull) => {
		const { group_supervisor, errors } = this.state;
		this.setState({
			group_supervisor: {
				...group_supervisor,
				employee_id: idOrNull ? Number(idOrNull) : -1,
			},
			errors: {
				...errors,
				employee_id: undefined,
			},
		});
	};

	handleSwitch = (event) => {
		const { id, checked } = event.target;

		this.setState({
			group_supervisor: applySupervisorPermissionChange(
				this.state.group_supervisor,
				{ id, checked }
			),
		});
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		const { isEdit } = this.state;

		if (
			!isEdit &&
			isSupervisorEmployeeMissing(this.state.group_supervisor.employee_id)
		) {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: {
					employee_id: this.props.t(
						"groups.supervisors.form.employeeRequired"
					),
				},
			});
			return;
		}

		this.setState({ isLoading: true });

		const props = this.props;
		const group_supervisor = normalizeSupervisorPermissions(
			this.state.group_supervisor
		);

		let response = "";
		var success_message = "";

		if (!isEdit) {
			response = await groupsService.addSupervisor(
				props.group.id,
				group_supervisor
			);

			success_message = this.props.t("groups.supervisors.form.added");
		} else {
			response = await groupsService.editSupervisor(
				props.group.id,
				group_supervisor
			);
			success_message = this.props.t("groups.supervisors.form.edited");
		}

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), success_message);
					this.props.getGroupSupervisors(props.group.id);
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	renderPermissionRow = (permission) => {
		const { group_supervisor, errors } = this.state;
		const Icon = permission.icon;

		return (
			<FormGroup
				key={permission.id}
				className="form-group group-supervisor-perm-row"
			>
				<span className="group-supervisor-perm-row__icon" aria-hidden>
					<Icon />
				</span>
				<FormLabel htmlFor={permission.id}>
					{this.props.t(permission.labelKey)}
				</FormLabel>
				<Switch
					controlId={permission.id}
					isOn={isPermissionEnabled(group_supervisor, permission)}
					disabled={isPermissionDisabled(group_supervisor, permission)}
					handleToggle={this.handleSwitch}
				/>
				{errors[permission.id] && (
					<FormControl.Feedback type="invalid">
						{errors[permission.id]}
					</FormControl.Feedback>
				)}
			</FormGroup>
		);
	};

	render() {
		const { isEdit, errors } = this.state;
		const permissionGroups = getSupervisorPermissionGroups(
			this.props.group.two_levels_workflow
		);

		return (
			<form className="group-supervisor-edit-form" onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<p className="group-supervisor-edit-form__intro">
						{this.props.t("groups.supervisors.form.description")}
					</p>

					<FormGroup className="form-group" controlId="employee_id">
						<FormLabel>
							{this.props.t("groups.supervisors.form.employee")}
							{!isEdit && <span className="label-required">*</span>}
						</FormLabel>
						<EmployeeSelectSearch
							className={`employee-select-search--fullwidth${
								errors.employee_id ? " employee-select-search--invalid" : ""
							}`}
							controlId="employee_id"
							multiple={false}
							allowClear={false}
							disabled={isEdit}
							value={
								this.state.group_supervisor.employee_id === -1
									? null
									: String(this.state.group_supervisor.employee_id)
							}
							onChange={this.handleSupervisorEmployeeChange}
							fetchOptions={this.employeeSelectFetchOptions}
							placeholder={this.props.t(
								"groups.supervisors.form.selectEmployee"
							)}
							knownEmployee={this.state.group_supervisor.employee || null}
						/>

						{errors.employee_id && (
							<div className="invalid-feedback d-block">
								{errors.employee_id}
							</div>
						)}
					</FormGroup>

					<div className="group-supervisor-permissions">
						<h3 className="group-supervisor-permissions__title">
							{this.props.t("groups.supervisors.form.permissions")}
						</h3>

						{permissionGroups.map((permissionGroup) => (
							<section
								key={permissionGroup.key}
								className="group-supervisor-permissions__group"
							>
								<div className="group-supervisor-permissions__label">
									{this.props.t(permissionGroup.labelKey)}
								</div>
								{permissionGroup.permissions.map(this.renderPermissionRow)}
							</section>
						))}
					</div>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.employeesReducer,
	};
};

export default connect(
	mapStateToProps,
	groupsActions
)(withTranslation()(GroupSupervisorEdit));
